// import React from "react";
// import gsap from "gsap";
// import { useGSAP } from "@gsap/react";
import Lenis from 'lenis'

import Header from '../components/header'
import Footer from '../components/footer'

function Project() {

     const lenis = new Lenis({
    duration: 2.2,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), 
    direction: 'vertical', // vertical, horizontal
    gestureDirection: 'vertical', // vertical, horizontal, both
    smooth: true,
    mouseMultiplier: 1,
    smoothTouch: true,
    touchMultiplier: 2,
    infinite: false,
  })


  function raf(time) {
    lenis.raf(time)
    requestAnimationFrame(raf)
    }
    
    requestAnimationFrame(raf)

    
    return(
      <section id="smooth-wrapper">
          <Header/>
          <main>
 
{/* <!--Start breadcrumb area-->      */}
{/* <section className="breadcrumb-area">
	<div className="container text-center">
		<h1>Our Projects</h1>
	</div>
</section> */}
{/* <!--End breadcrumb area--> */}

{/* <!--Start breadcrumb bottom area--> */}
{/* <section className="breadcrumb-botton-area">
    <div className="container">
        <div className="left">
            <ul>
                <li><a href="/">Home</a></li>
                <li><i className="fa fa-caret-right" aria-hidden="true"></i></li>
                <li className="active">Our Projects</li>
            </ul>    
        </div>
    </div>
</section> */}
{/* <!--End breadcrumb bottom area--> */}

{/* <!--Start project with text area-->  */}
<section className="main-project-area">
    <div className="container">
        <div className="row">
            <div className="col-md-12">
                <ul className="project-filter post-filter text-center">
                    <li className="active" data-filter=".filter-item"><span>View All</span></li>
                    <li data-filter=".airconditioning"><span>Airconditioning</span></li>
                    <li data-filter=".heating"><span>Heating & Furnace</span></li>
                    <li data-filter=".maintenance"><span>Maintenance</span></li>
                    <li data-filter=".energy"><span>Energy Efficiency</span></li>
                </ul>
            </div>
        </div>
        <div className="row project-content masonary-layout filter-layout">
            {/* <!--Start single project item--> */}
            <div className="col-md-4 col-sm-4 col-xs-12 filter-item maintenance airconditioning">
                <div className="single-project-item">
                    <div className="img-holder">
                        <img src="assets/images/projects/1.jpg" alt="Awesome Image"/>
                        <div className="overlay-style-one">
                            <div className="box">
                                <div className="content">
                                    <a href="projects-single.html">View Project</a>
                                    <div className="text-holder">
                                        <h4>Air Conditioner Installation</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>   
                </div> 
            </div>
            {/* <!--End single project item--> */}
            {/* <!--Start single project item--> */}
            <div className="col-md-4 col-sm-4 col-xs-12 filter-item energy maintenance">
                <div className="single-project-item">
                    <div className="img-holder">
                        <img src="assets/images/projects/2.jpg" alt="Awesome Image"/>
                        <div className="overlay-style-one">
                            <div className="box">
                                <div className="content">
                                    <a href="projects-single.html">View Project</a>
                                    <div className="text-holder">
                                        <h4>Air Conditioner Installation</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>   
                </div> 
            </div>
            {/* <!--End single project item--> */}
            {/* <!--Start single project item--> */}
            <div className="col-md-4 col-sm-4 col-xs-12 filter-item energy heating">
                <div className="single-project-item">
                    <div className="img-holder">
                        <img src="assets/images/projects/3.jpg" alt="Awesome Image"/>
                        <div className="overlay-style-one">
                            <div className="box">
                                <div className="content">
                                    <a href="projects-single.html">View Project</a>
                                    <div className="text-holder">
                                        <h4>Air Conditioner Installation</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>   
                </div> 
            </div>
            {/* <!--End single project item--> */}
            {/* <!--Start single project item--> */}
            <div className="col-md-4 col-sm-4 col-xs-12 filter-item heating airconditioning">
                <div className="single-project-item">
                    <div className="img-holder">
                        <img src="assets/images/projects/4.jpg" alt="Awesome Image"/>
                        <div className="overlay-style-one">
                            <div className="box">
                                <div className="content">
                                    <a href="projects-single.html">View Project</a>
                                    <div className="text-holder">
                                        <h4>Air Conditioner Installation</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>   
                </div> 
            </div>
            {/* <!--End single project item--> */}
            {/* <!--Start single project item--> */}
            <div className="col-md-4 col-sm-4 col-xs-12 filter-item airconditioning heating energy">
                <div className="single-project-item">
                    <div className="img-holder">
                        <img src="assets/images/projects/5.jpg" alt="Awesome Image"/>
                        <div className="overlay-style-one">
                            <div className="box">
                                <div className="content">
                                    <a href="projects-single.html">View Project</a>
                                    <div className="text-holder">
                                        <h4>Air Conditioner Installation</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>   
                </div> 
            </div>
            {/* <!--End single project item--> */}
            {/* <!--Start single project item--> */}
            <div className="col-md-4 col-sm-4 col-xs-12 filter-item heating energy">
                <div className="single-project-item">
                    <div className="img-holder">
                        <img src="assets/images/projects/6.jpg" alt="Awesome Image"/>
                        <div className="overlay-style-one">
                            <div className="box">
                                <div className="content">
                                    <a href="projects-single.html">View Project</a>
                                    <div className="text-holder">
                                        <h4>Air Conditioner Installation</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>   
                </div> 
            </div>
            {/* <!--End single project item--> */}
            {/* <!--Start single project item--> */}
            <div className="col-md-4 col-sm-4 col-xs-12 filter-item airconditioning maintenance">
                <div className="single-project-item">
                    <div className="img-holder">
                        <img src="assets/images/projects/7.jpg" alt="Awesome Image"/>
                        <div className="overlay-style-one">
                            <div className="box">
                                <div className="content">
                                    <a href="projects-single.html">View Project</a>
                                    <div className="text-holder">
                                        <h4>Air Conditioner Installation</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>   
                </div> 
            </div>
            {/* <!--End single project item--> */}
            {/* <!--Start single project item--> */}
            <div className="col-md-4 col-sm-4 col-xs-12 filter-item heating energy airconditioning">
                <div className="single-project-item">
                    <div className="img-holder">
                        <img src="assets/images/projects/8.jpg" alt="Awesome Image"/>
                        <div className="overlay-style-one">
                            <div className="box">
                                <div className="content">
                                    <a href="projects-single.html">View Project</a>
                                    <div className="text-holder">
                                        <h4>Air Conditioner Installation</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>   
                </div> 
            </div>
            {/* <!--End single project item--> */}
            {/* <!--Start single project item--> */}
            <div className="col-md-4 col-sm-4 col-xs-12 filter-item energy airconditioning heating">
                <div className="single-project-item">
                    <div className="img-holder">
                        <img src="assets/images/projects/9.jpg" alt="Awesome Image"/>
                        <div className="overlay-style-one">
                            <div className="box">
                                <div className="content">
                                    <a href="projects-single.html">View Project</a>
                                    <div className="text-holder">
                                        <h4>Air Conditioner Installation</h4>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>   
                </div> 
            </div>
            {/* <!--End single project item--> */}
        </div>
        <div className="row">
            <div className="col-md-12"> 
                <ul className="post-pagination text-center">
                    <li><a href="#"><i className="fa fa-caret-left" aria-hidden="true"></i></a></li>
                    <li className="active"><a href="#">1</a></li>
                    <li><a href="#">2</a></li>
                    <li><a href="#">3</a></li>
                    <li><a href="#"><i className="fa fa-caret-right" aria-hidden="true"></i></a></li>
                </ul>
            </div> 
        </div>
    </div>
</section>                            
{/* <!--End project with text area-->    */}

          </main>
          <Footer/>
      </section>
    )
 }
 
 export default Project;


